import { useEffect, useState, useCallback } from 'react';
// @mui
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
// routes
import { paths } from 'src/routes/paths';
import { useParams } from 'src/routes/hook';
// types
import { HTTaiKhoan } from 'src/types/api-response';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import EmptyContent from 'src/components/empty-content';
// hooks
import { useAccount } from '../hooks/use-account';
//
import AccountNewEditForm from '../account-new-edit-form';

// ----------------------------------------------------------------------

export default function AccountEditView() {
  const settings = useSettingsContext();
  const params = useParams();
  const { id } = params;
  
  // Sử dụng hook lấy chi tiết
  const { getAccountById } = useAccount();

  const [currentAccount, setCurrentAccount] = useState<HTTaiKhoan | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchAccount = useCallback(async () => {
    if (!id) return;

    setLoading(true);
    try {
      const data = await getAccountById(id);
      setCurrentAccount(data);
    } catch (error) {
      console.error('Error fetching account:', error);
    } finally {
      setLoading(false);
    }
  }, [id, getAccountById]);

  useEffect(() => {
    fetchAccount();
  }, [fetchAccount]);

  if (loading) {
    return (
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (!currentAccount) {
    return (
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <EmptyContent filled title="Không tìm thấy tài khoản" sx={{ py: 10 }} />
      </Container>
    );
  }

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Chỉnh sửa tài khoản"
        links={[
          { name: 'Dashboard', href: paths.dashboard.root },
          { name: 'Tài khoản', href: paths.dashboard.user.list },
          { name: currentAccount.tenTaiKhoan || 'Chỉnh sửa' },
        ]}
        sx={{ mb: { xs: 3, md: 5 } }}
      />
      
      <AccountNewEditForm currentAccount={currentAccount} />
    </Container>
  );
}